/* ALMUSAFIR — TRAVEL GLOBE v3 */
(function () {
  'use strict';

  var ALIASES = {
    'uk': 'united kingdom',
    'usa': 'united states of america',
    'us': 'united states of america',
    'united states': 'united states of america',
    'america': 'united states of america',
    'uae': 'united arab emirates',
    'emirates': 'united arab emirates',
    'saudi': 'saudi arabia',
    'ksa': 'saudi arabia',
    'drc': 'dem. rep. congo',
    'democratic republic of congo': 'dem. rep. congo',
    'congo drc': 'dem. rep. congo',
    'ivory coast': 'cote divoire',
    'burma': 'myanmar',
    'holland': 'netherlands',
    'czechia': 'czech',
    'bosnia': 'bosnia and herz.',
    'sa': 'south africa',
    'nz': 'new zealand',
    'palestine': 'palestine'
  };

  function norm(s) {
    return s.toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/['’.]/g, '')
      .trim();
  }


  var CONTINENT_LISTS = {
    'Africa': ['Algeria','Angola','Benin','Botswana','Burkina Faso','Burundi','Cabo Verde','Cape Verde','Cameroon','Central African Rep.','Chad','Comoros','Congo','Cote dIvoire','Dem. Rep. Congo','Djibouti','Egypt','Eq. Guinea','Eritrea','eSwatini','Swaziland','Ethiopia','Gabon','Gambia','Ghana','Guinea','Guinea-Bissau','Kenya','Lesotho','Liberia','Libya','Madagascar','Malawi','Mali','Mauritania','Mauritius','Morocco','Mozambique','Namibia','Niger','Nigeria','Rwanda','Sao Tome and Principe','Senegal','Seychelles','Sierra Leone','Somalia','Somaliland','South Africa','S. Sudan','Sudan','Tanzania','Togo','Tunisia','Uganda','W. Sahara','Zambia','Zimbabwe'],
    'Europe': ['Albania','Andorra','Austria','Belarus','Belgium','Bosnia and Herz.','Bulgaria','Croatia','Czechia','Czech Rep.','Denmark','Estonia','Finland','France','Germany','Greece','Hungary','Iceland','Ireland','Italy','Kosovo','Latvia','Liechtenstein','Lithuania','Luxembourg','Malta','Moldova','Monaco','Montenegro','Netherlands','North Macedonia','Macedonia','Norway','Poland','Portugal','Romania','Russia','San Marino','Serbia','Slovakia','Slovenia','Spain','Sweden','Switzerland','Ukraine','United Kingdom','Vatican','Faeroe Is.','Isle of Man','Jersey','Guernsey','Gibraltar','Aland'],
    'Asia': ['Afghanistan','Armenia','Azerbaijan','Bahrain','Bangladesh','Bhutan','Brunei','Cambodia','China','Cyprus','N. Cyprus','Georgia','Hong Kong','India','Indonesia','Iran','Iraq','Israel','Japan','Jordan','Kazakhstan','Kuwait','Kyrgyzstan','Laos','Lebanon','Macao','Malaysia','Maldives','Mongolia','Myanmar','Nepal','North Korea','Oman','Pakistan','Palestine','Philippines','Qatar','Saudi Arabia','Singapore','South Korea','Korea','Sri Lanka','Syria','Taiwan','Tajikistan','Thailand','Timor-Leste','Turkey','Turkmenistan','United Arab Emirates','Uzbekistan','Vietnam','Yemen'],
    'North America': ['Antigua and Barb.','Bahamas','Barbados','Belize','Bermuda','Canada','Cayman Is.','Costa Rica','Cuba','Curacao','Dominica','Dominican Rep.','El Salvador','Greenland','Grenada','Guatemala','Haiti','Honduras','Jamaica','Mexico','Nicaragua','Panama','Puerto Rico','St. Kitts and Nevis','Saint Lucia','St. Vin. and Gren.','Trinidad and Tobago','Turks and Caicos Is.','United States of America','Aruba','U.S. Virgin Is.','British Virgin Is.','Anguilla','Montserrat','St-Martin','Sint Maarten','St. Pierre and Miquelon'],
    'South America': ['Argentina','Bolivia','Brazil','Chile','Colombia','Ecuador','Falkland Is.','Guyana','Paraguay','Peru','Suriname','Uruguay','Venezuela'],
    'Australia': ['Australia','Fiji','Kiribati','Marshall Is.','Micronesia','Nauru','New Caledonia','New Zealand','Niue','Palau','Papua New Guinea','Samoa','American Samoa','Solomon Is.','Tonga','Tuvalu','Vanuatu','Fr. Polynesia','Guam','Cook Is.','N. Mariana Is.','Norfolk Island','Pitcairn Is.','Wallis and Futuna Is.'],
    'Antarctica': ['Antarctica','Fr. S. Antarctic Lands','Heard I. and McDonald Is.']
  };
  var CONTINENT_ORDER = ['Africa','Asia','Europe','North America','South America','Australia','Antarctica'];
  var NAME_TO_CONTINENT = {};
  Object.keys(CONTINENT_LISTS).forEach(function (cont) {
    CONTINENT_LISTS[cont].forEach(function (n) { NAME_TO_CONTINENT[norm(n)] = cont; });
  });

  function continentByCoords(lat, lng) {
    if (lat < -60) return 'Antarctica';
    if (lng >= -30 && lng <= 52 && lat <= 37 && lat >= -35) return 'Africa';
    if (lng < -30) return lat >= 13 ? 'North America' : 'South America';
    if (lng >= 110 && lat < -8) return 'Australia';
    if (lng >= 150 || lng <= -140) return 'Australia';
    if (lat >= 36 && lng >= -25 && lng <= 45) return 'Europe';
    return 'Asia';
  }

  function continentOf(f, centroidFn) {
    var c = NAME_TO_CONTINENT[norm(f.properties.name)];
    if (c) return c;
    var p = centroidFn(f);
    return continentByCoords(p.lat, p.lng);
  }

  function loadScript(src) {
    return new Promise(function (res, rej) {
      var s = document.createElement('script');
      s.src = src; s.async = true; s.onload = res; s.onerror = rej;
      document.head.appendChild(s);
    });
  }

  function initSection(root) {
    if (root.dataset.tgBooted) return;
    root.dataset.tgBooted = '1';

    var CFG = {
      denominator: root.dataset.denominator || 'map',
      oceanColor: root.dataset.oceanColor || '#1E2260',
      landColor: root.dataset.landColor || '#D6F0FA',
      visitedColor: root.dataset.visitedColor || '#29ABE2',
      shareText: root.dataset.shareText || "I've explored {pct}% of the world with Almusafir - how far have you wandered?",
      cardBrand: root.dataset.cardBrand || 'ALMUSAFIR',
      cardDomain: root.dataset.cardDomain || 'almusafir.co.za',
      cardTagline: root.dataset.cardTagline || 'of the world explored'
    };

    var el = root.querySelector('.tg-globe');
    var note = root.querySelector('.tg-note');
    var pctEl = root.querySelector('.tg-pct-val');
    var visEl = root.querySelector('.tg-vis');
    var totalEl = root.querySelector('.tg-total');
    var barEl = root.querySelector('.tg-bar');
    var searchEl = root.querySelector('.tg-search');
    var suggestEl = root.querySelector('.tg-suggest');
    var chipsEl = root.querySelector('.tg-chips');

    var toast = document.createElement('div');
    toast.className = 'tg-toast';
    document.body.appendChild(toast);
    var toastTimer;
    function showToast(msg) {
      toast.textContent = msg;
      toast.classList.add('is-on');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.classList.remove('is-on'); }, 2000);
    }

    var visited = new Set();
    var features = [];
    var byId = {};

    var world = Globe({ rendererConfig: { preserveDrawingBuffer: true, antialias: true, alpha: true } })(el)
      .backgroundColor('rgba(0,0,0,0)')
      .showAtmosphere(true)
      .atmosphereColor('#29ABE2')
      .atmosphereAltitude(0.16)
      .polygonsTransitionDuration(300)
      .width(el.clientWidth)
      .height(el.clientHeight);

    world.globeMaterial().color.set(CFG.oceanColor);
    world.globeMaterial().shininess = 5;

    window.addEventListener('resize', function () {
      world.width(el.clientWidth).height(el.clientHeight);
    });

    var ctrl = world.controls();
    ctrl.autoRotate = true;
    ctrl.autoRotateSpeed = 0.4;
    /* wheel/pinch zoom off so the globe never traps page scrolling; buttons below handle zoom */
    ctrl.enableZoom = false;
    ['mousedown', 'touchstart'].forEach(function (ev) {
      el.addEventListener(ev, function () { ctrl.autoRotate = false; }, { passive: true });
    });

    function zoomBy(f) {
      var pov = world.pointOfView();
      var alt = Math.min(3.0, Math.max(0.35, pov.altitude * f));
      world.pointOfView({ lat: pov.lat, lng: pov.lng, altitude: alt }, 320);
    }
    root.querySelector('.tg-zoom-in').addEventListener('click', function () { ctrl.autoRotate = false; zoomBy(0.62); });
    root.querySelector('.tg-zoom-out').addEventListener('click', function () { ctrl.autoRotate = false; zoomBy(1.6); });

    function denomTotal() { return CFG.denominator === '195' ? 195 : (features.length || 1); }

    function currentPct() {
      var pct = Math.round((visited.size / denomTotal()) * 1000) / 10;
      return Math.min(pct, 100);
    }

    var continentTotals = null;
    function buildContinentTotals() {
      continentTotals = {};
      CONTINENT_ORDER.forEach(function (c) { continentTotals[c] = 0; });
      features.forEach(function (f) {
        var c = continentOf(f, centroid);
        f.__cont = c;
        if (continentTotals[c] === undefined) continentTotals[c] = 0;
        continentTotals[c] += 1;
      });
    }

    function renderChips() {
      chipsEl.innerHTML = '';
      if (!visited.size) { chipsEl.style.display = 'none'; return; }
      if (!continentTotals) buildContinentTotals();

      var groups = {};
      Array.from(visited).forEach(function (id) {
        var f = byId[id];
        if (!f) return;
        var c = f.__cont || continentOf(f, centroid);
        (groups[c] = groups[c] || []).push(f);
      });

      CONTINENT_ORDER.forEach(function (cont) {
        var total = continentTotals[cont] || 0;
        if (!total) return;
        var sel = (groups[cont] || []).sort(function (a, b) {
          return a.properties.name.localeCompare(b.properties.name);
        });
        var pct = Math.round((sel.length / total) * 100);

        var block = document.createElement('div');
        block.className = 'tg-cont';

        var head = document.createElement('div');
        head.className = 'tg-cont-head';
        head.innerHTML = '<span class="tg-cont-name">' + cont + '</span>' +
          '<span class="tg-cont-stat">' + sel.length + ' of ' + total + ' &middot; ' + pct + '%</span>';
        block.appendChild(head);

        var bar = document.createElement('div');
        bar.className = 'tg-cont-meter';
        bar.innerHTML = '<i style="width:' + pct + '%"></i>';
        block.appendChild(bar);

        if (sel.length) {
          var row = document.createElement('div');
          row.className = 'tg-cont-chips';
          sel.forEach(function (f) {
            var chip = document.createElement('button');
            chip.type = 'button';
            chip.className = 'tg-chip';
            chip.setAttribute('aria-label', 'Remove ' + f.properties.name);
            chip.innerHTML = '<span>' + f.properties.name + '</span><i aria-hidden="true">&times;</i>';
            chip.addEventListener('click', function () {
              visited.delete(f.id);
              showToast('Removed: ' + f.properties.name);
              refresh();
            });
            row.appendChild(chip);
          });
          block.appendChild(row);
        }
        chipsEl.appendChild(block);
      });
      chipsEl.style.display = 'block';
    }

    function refresh() {
      world.polygonCapColor(world.polygonCapColor()).polygonAltitude(world.polygonAltitude());
      var pct = currentPct();
      pctEl.textContent = (pct % 1 === 0) ? pct : pct.toFixed(1);
      visEl.textContent = visited.size;
      barEl.style.width = Math.min(visited.size / denomTotal() * 100, 100) + '%';
      renderChips();
      var h = Array.from(visited).join('-');
      try {
        history.replaceState(null, '', h ? ('#tg=' + h) : location.pathname + location.search);
      } catch (e) {}
      try {
        if (h) { localStorage.setItem('almusafir_tg', h); } else { localStorage.removeItem('almusafir_tg'); }
      } catch (e) {}
    }

    function toggle(f) {
      if (visited.has(f.id)) {
        visited.delete(f.id);
        showToast('Removed: ' + f.properties.name);
      } else {
        visited.add(f.id);
        showToast('Marked: ' + f.properties.name);
      }
      refresh();
    }

    function centroid(f) {
      var x = 0, y = 0, c = 0;
      (function walk(a) {
        if (typeof a[0] === 'number') { x += a[0]; y += a[1]; c++; }
        else a.forEach(walk);
      })(f.geometry.coordinates);
      return { lng: x / c, lat: y / c };
    }

    function resolveCountry(q) {
      var n = norm(q);
      if (!n) return null;
      if (ALIASES[n]) n = ALIASES[n];
      var exact = features.find(function (f) { return norm(f.properties.name) === n; });
      if (exact) return exact;
      var starts = features.filter(function (f) { return norm(f.properties.name).indexOf(n) === 0; });
      if (starts.length === 1) return starts[0];
      var contains = features.filter(function (f) { return norm(f.properties.name).indexOf(n) !== -1; });
      if (contains.length === 1) return contains[0];
      return null;
    }

    fetch('https://unpkg.com/world-atlas@2.0.2/countries-50m.json')
      .then(function (r) { return r.json(); })
      .then(function (topo) {
        features = topojson.feature(topo, topo.objects.countries).features;
        features.forEach(function (f) { byId[f.id] = f; });

        world
          .polygonsData(features)
          .polygonAltitude(function (f) { return visited.has(f.id) ? 0.05 : 0.008; })
          .polygonCapColor(function (f) { return visited.has(f.id) ? CFG.visitedColor : CFG.landColor; })
          .polygonSideColor(function () { return 'rgba(20,40,70,0.35)'; })
          .polygonStrokeColor(function () { return 'rgba(20,40,70,0.6)'; })
          .polygonLabel(function (f) {
            return '<div style="font-family:Nunito,sans-serif;font-size:12px;font-weight:700;background:#1E2260;color:#fff;padding:5px 10px;border-radius:6px;">' + f.properties.name + '</div>';
          })
          .onPolygonClick(toggle)
          .onPolygonHover(function (h) { el.style.cursor = h ? 'pointer' : 'grab'; });

        totalEl.textContent = denomTotal();

        var m = location.hash.match(/tg=([0-9-]+)/);
        var saved = null;
        try { saved = localStorage.getItem('almusafir_tg'); } catch (e) {}
        var src = m ? m[1] : saved;
        if (src) {
          src.split('-').forEach(function (id) { if (byId[id]) visited.add(id); });
          if (!m && visited.size) showToast('Welcome back - your map is loaded');
        }

        note.classList.add('is-hidden');
        refresh();
      })
      .catch(function () {
        note.textContent = 'Could not load the map data. Please refresh.';
      });

    function pick(f) {
      hideSuggest();
      if (!visited.has(f.id)) {
        visited.add(f.id);
        showToast('Marked: ' + f.properties.name);
        refresh();
      }
      ctrl.autoRotate = false;
      var c = centroid(f);
      world.pointOfView({ lat: c.lat, lng: c.lng, altitude: 1.2 }, 900);
      searchEl.value = '';
    }

    function matches(q) {
      var n = norm(q);
      if (!n) return [];
      var out = [], seen = {};
      function push(f) { if (f && !seen[f.id]) { seen[f.id] = 1; out.push(f); } }
      Object.keys(ALIASES).forEach(function (k) {
        if (k.indexOf(n) === 0) {
          var t = ALIASES[k];
          push(features.find(function (f) { return norm(f.properties.name) === t; }));
        }
      });
      features.forEach(function (f) { if (norm(f.properties.name).indexOf(n) === 0) push(f); });
      features.forEach(function (f) { if (norm(f.properties.name).indexOf(n) > 0) push(f); });
      return out.slice(0, 8);
    }

    var activeIdx = -1;
    function hideSuggest() { suggestEl.hidden = true; suggestEl.innerHTML = ''; activeIdx = -1; }
    function renderSuggest() {
      var list = matches(searchEl.value);
      if (!list.length) { hideSuggest(); return; }
      suggestEl.innerHTML = '';
      list.forEach(function (f, i) {
        var li = document.createElement('li');
        li.textContent = f.properties.name + (visited.has(f.id) ? ' (marked)' : '');
        li.setAttribute('role', 'option');
        if (i === activeIdx) li.className = 'is-active';
        /* mousedown fires before the input blur, so taps register */
        li.addEventListener('mousedown', function (e) { e.preventDefault(); pick(f); });
        li.addEventListener('touchstart', function (e) { e.preventDefault(); pick(f); }, { passive: false });
        suggestEl.appendChild(li);
      });
      suggestEl.hidden = false;
    }

    function doSearch() {
      var list = matches(searchEl.value);
      var f = (activeIdx >= 0 && list[activeIdx]) ? list[activeIdx] : (resolveCountry(searchEl.value) || list[0]);
      if (!f) {
        if (searchEl.value.trim()) showToast('Could not find that country');
        return;
      }
      pick(f);
    }

    searchEl.addEventListener('input', function () { activeIdx = -1; renderSuggest(); });
    searchEl.addEventListener('focus', renderSuggest);
    searchEl.addEventListener('blur', function () { setTimeout(hideSuggest, 150); });
    searchEl.addEventListener('keydown', function (e) {
      var items = suggestEl.querySelectorAll('li');
      if (e.key === 'ArrowDown' && items.length) { e.preventDefault(); activeIdx = (activeIdx + 1) % items.length; renderSuggest(); }
      else if (e.key === 'ArrowUp' && items.length) { e.preventDefault(); activeIdx = (activeIdx - 1 + items.length) % items.length; renderSuggest(); }
      else if (e.key === 'Enter') { e.preventDefault(); doSearch(); }
      else if (e.key === 'Escape') { hideSuggest(); }
    });
    var goBtn = root.querySelector('.tg-search-go');
    if (goBtn) goBtn.addEventListener('click', doSearch);

    root.querySelector('.tg-reset').addEventListener('click', function () {
      if (!visited.size) return;
      visited.clear();
      showToast('Map cleared');
      refresh();
    });

    root.querySelector('.tg-share-link').addEventListener('click', function () {
      var url = location.origin + location.pathname + '#tg=' + Array.from(visited).join('-');
      var text = CFG.shareText.replace('{pct}', pctEl.textContent);
      if (navigator.share) {
        navigator.share({ title: 'Almusafir', text: text, url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () { showToast('Link copied - send it to a friend'); });
      }
    });

    root.querySelector('.tg-share-img').addEventListener('click', function () {
      var W = 1080, H = 1350;
      var c = document.createElement('canvas');
      c.width = W; c.height = H;
      var x = c.getContext('2d');

      var g = x.createLinearGradient(0, 0, 0, H);
      g.addColorStop(0, '#1E2260');
      g.addColorStop(1, '#101340');
      x.fillStyle = g;
      x.fillRect(0, 0, W, H);

      x.textAlign = 'center';
      x.fillStyle = '#7ECFF0';
      x.font = '700 30px Nunito, sans-serif';
      x.fillText(CFG.cardBrand.split('').join(String.fromCharCode(8202)), W / 2, 110);

      var drewGlobe = false;
      try {
        var src = el.querySelector('canvas');
        if (src && src.width > 0) {
          var size = 720;
          var sMin = Math.min(src.width, src.height);
          x.save();
          x.beginPath();
          x.arc(W / 2, 560, size / 2, 0, Math.PI * 2);
          x.clip();
          x.drawImage(src, (src.width - sMin) / 2, (src.height - sMin) / 2, sMin, sMin, W / 2 - size / 2, 560 - size / 2, size, size);
          x.restore();
          drewGlobe = true;
        }
      } catch (e) {}

      if (!drewGlobe) {
        /* fallback: simple globe mark so the card never looks broken */
        x.strokeStyle = '#29ABE2';
        x.lineWidth = 6;
        x.beginPath(); x.arc(W / 2, 560, 300, 0, Math.PI * 2); x.stroke();
        x.beginPath(); x.ellipse(W / 2, 560, 300, 120, 0, 0, Math.PI * 2); x.stroke();
        x.beginPath(); x.ellipse(W / 2, 560, 120, 300, 0, 0, Math.PI * 2); x.stroke();
      }

      x.fillStyle = '#FFFFFF';
      x.font = '700 190px "Playfair Display", serif';
      x.fillText(pctEl.textContent + '%', W / 2, 1090);

      x.fillStyle = '#7ECFF0';
      x.font = '700 30px Nunito, sans-serif';
      x.fillText(CFG.cardTagline.toUpperCase(), W / 2, 1150);

      x.fillStyle = 'rgba(255,255,255,0.55)';
      x.font = '600 24px Nunito, sans-serif';
      x.fillText(visEl.textContent + ' countries - ' + CFG.cardDomain, W / 2, 1240);

      c.toBlob(function (blob) {
        if (!blob) return;
        var file = new File([blob], 'almusafir-atlas.png', { type: 'image/png' });
        if (navigator.canShare && navigator.canShare({ files: [file] })) {
          navigator.share({ files: [file], title: 'Almusafir' }).catch(function () {});
        } else {
          var a = document.createElement('a');
          a.href = URL.createObjectURL(blob);
          a.download = 'almusafir-atlas.png';
          a.click();
          setTimeout(function () { URL.revokeObjectURL(a.href); }, 4000);
          showToast('Image saved');
        }
      }, 'image/png');
    });
  }

  function boot(root) {
    Promise.all([
      loadScript('https://unpkg.com/globe.gl'),
      loadScript('https://unpkg.com/topojson-client@3')
    ]).then(function () { initSection(root); }).catch(function () {
      var n = root.querySelector('.tg-note');
      if (n) n.textContent = 'Could not load the globe. Please refresh.';
    });
  }

  function watch() {
    document.querySelectorAll('.tg-wrap').forEach(function (root) {
      if (root.dataset.tgWatched) return;
      root.dataset.tgWatched = '1';
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { boot(root); io.disconnect(); }
          });
        }, { rootMargin: '400px' });
        io.observe(root);
      } else {
        boot(root);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
  document.addEventListener('shopify:section:load', watch);
})();
